import type { PurchaseEvent } from '../types/tracking.types';

/**
 * Envia evento de conversão para Google Ads
 */
export const sendToGoogleAds = (adsId: string, event: PurchaseEvent, universalEventId: string): void => {
  if (!adsId || !window.gtag || !event.ads_data) return;
  
  try {
    // Envia user_data (email) se disponível
    if (event.user_email) {
      window.gtag?.('set', 'user_data', {
        email: event.user_email,
      });
    }
    
    // Para compras, prioriza o transaction_id original, mas adiciona o universal como fallback
    // Valida transaction_id para evitar NaN
    const transactionId = event.ads_data.transaction_id && event.ads_data.transaction_id !== 'NaN' 
      ? event.ads_data.transaction_id 
      : universalEventId;
    
    const adsData = {
      send_to: adsId,  // Usa o adsId completo (AW-XXXXXXXXX/ROTULO_CONVERSAO)
      value: event.ads_data.value,
      currency: event.ads_data.currency,
      transaction_id: transactionId,
      // Google Ads espera 'id' (não 'item_id') + google_business_vertical para remarketing dinâmico
      ...(event.ecommerce.items && {
        items: event.ecommerce.items.map(item => ({
          ...item,
          id: item.item_id,
          google_business_vertical: 'retail',
        })),
        item_list_id: 'purchase_items',
        item_list_name: 'Purchase Items'
      })
    };

    window.gtag?.('event', 'conversion', adsData);
  } catch (error) {
    console.error(`❌ Google Ads: Erro ao enviar evento para ${adsId}:`, error);
  }
}; 